var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#264254"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.847C18.314 16.103 17.75 16.822 17.75 17.5C17.75 18.178 18.314 18.897 19.25 19.152V15.847ZM20.75 20.848V24.152C21.686 23.897 22.25 23.178 22.25 22.5C22.25 21.822 21.686 21.103 20.75 20.848Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20C30 25.523 25.523 30 20 30C14.477 30 10 25.523 10 20C10 14.477 14.477 10 20 10C25.523 10 30 14.477 30 20ZM20 13.25C20.1989 13.25 20.3897 13.329 20.5303 13.4697C20.671 13.6103 20.75 13.8011 20.75 14V14.317C22.38 14.609 23.75 15.834 23.75 17.5C23.75 17.6989 23.671 17.8897 23.5303 18.0303C23.3897 18.171 23.1989 18.25 23 18.25C22.8011 18.25 22.6103 18.171 22.4697 18.0303C22.329 17.8897 22.25 17.6989 22.25 17.5C22.25 16.822 21.686 16.103 20.75 15.847V19.317C22.38 19.609 23.75 20.834 23.75 22.5C23.75 24.166 22.38 25.391 20.75 25.683V26C20.75 26.1989 20.671 26.3897 20.5303 26.5303C20.3897 26.671 20.1989 26.75 20 26.75C19.8011 26.75 19.6103 26.671 19.4697 26.5303C19.329 26.3897 19.25 26.1989 19.25 26V25.683C17.62 25.391 16.25 24.166 16.25 22.5C16.25 22.3011 16.329 22.1103 16.4697 21.9697C16.6103 21.829 16.8011 21.75 17 21.75C17.1989 21.75 17.3897 21.829 17.5303 21.9697C17.671 22.1103 17.75 22.3011 17.75 22.5C17.75 23.178 18.314 23.897 19.25 24.152V20.683C17.62 20.391 16.25 19.166 16.25 17.5C16.25 15.834 17.62 14.609 19.25 14.317V14C19.25 13.8011 19.329 13.6103 19.4697 13.4697C19.6103 13.329 19.8011 13.25 20 13.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.6215f37be83aca50e2b08ae3e34ce923.svg";
export { ForwardRef as ReactComponent };